"use client";

import { useEffect, useState } from "react";
import { useTheme } from "next-themes";

import { Nav } from "./sections";

export const LandingHeader = () => {
  const { resolvedTheme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  const theme: "dark" | "light" =
    mounted && resolvedTheme === "dark" ? "dark" : "light";

  const toggleTheme = () => setTheme(theme === "dark" ? "light" : "dark");

  return <Nav theme={theme} onToggleTheme={toggleTheme} />;
};
